import type { CompareProduct } from '@/compare/types';

const STORAGE_KEY = 'nuvoo_compare_products';
const COUNTRY_KEY = 'nuvoo_compare_country';

/**
 * Get products from localStorage
 */
export function getCompareProducts(): CompareProduct[] {
  const currentLocale = document.documentElement.lang;
  const storedLocale = localStorage.getItem(COUNTRY_KEY);

  if (storedLocale && storedLocale !== currentLocale) {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.setItem(COUNTRY_KEY, currentLocale);
    return [];
  }

  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function setCompareProducts(products: CompareProduct[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
  localStorage.setItem(COUNTRY_KEY, document.documentElement.lang);
}

/**
 * Build shareable compare URL
 */
export function buildCompareUrl(products: CompareProduct[]) {
  const url = new URL(window.location.href);

  url.searchParams.delete('id');

  products.forEach((p) => {
    url.searchParams.append('id', p.id);
  });

  return url.toString();
}
